import React, { useEffect, useState } from 'react';
import { companyAdminAPI } from '../../lib/walletApi';
import { Card, CardContent } from '../../components/ui/card';
import { Users, Wallet, FileSpreadsheet, CreditCard, Loader2 } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

export default function CompanyDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try { setStats(await companyAdminAPI.getDashboard()); }
      catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    load();
  }, []);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-pink-400" /></div>;

  const cards = [
    { label: 'Employees', value: stats?.total_employees || 0, icon: Users, color: 'bg-pink-50 text-pink-600' },
    { label: 'Active Wallets', value: stats?.active_wallets || 0, icon: Wallet, color: 'bg-blue-50 text-blue-600' },
    { label: 'Payroll Runs', value: stats?.payroll_runs || 0, icon: FileSpreadsheet, color: 'bg-violet-50 text-violet-600' },
    { label: 'Total Payouts', value: stats?.total_payouts || 0, icon: CreditCard, color: 'bg-emerald-50 text-emerald-600' },
  ];

  return (
    <div className="space-y-6" data-testid="ca-dashboard">
      <div>
        <p className="text-sm text-gray-400">{new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}</p>
        <h1 className="text-2xl font-bold text-gray-900">Company Dashboard</h1>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(s => (
          <Card key={s.label} className="border-gray-200 shadow-sm">
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs text-gray-500 font-medium">{s.label}</span>
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${s.color}`}><s.icon className="w-4 h-4" /></div>
              </div>
              <p className="text-2xl font-bold text-gray-900">{s.value}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
